function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { Trackable } from "@dpdgroupuk/react-event-tracker";
import useModalController from "../../hooks/useModalController";
import { DIALOG_TYPE } from "../../constants/dialogTypes";
import ConfirmationModal from "./Confirmation";
import ErrorModal from "./Error";
const ModalContext = /*#__PURE__*/React.createContext({
  showModal: () => Promise.resolve()
});

const Modal = ({
  type,
  ...props
}) => type === DIALOG_TYPE.CONFIRMATION ? /*#__PURE__*/React.createElement(ConfirmationModal, props) : /*#__PURE__*/React.createElement(ErrorModal, props);

const Provider = ({
  children
}) => {
  const [modalProps, showModal, hideModal] = useModalController();
  const contextValue = React.useMemo(() => ({
    showModal,
    hideModal
  }), [showModal, hideModal]);
  return /*#__PURE__*/React.createElement(ModalContext.Provider, {
    value: contextValue
  }, children, /*#__PURE__*/React.createElement(Modal, modalProps));
};

export default Provider;
export const useModal = () => React.useContext(ModalContext);
export const withModal = Component => props => /*#__PURE__*/React.createElement(ModalContext.Consumer, null, context => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
  modal: context
})));
export const TrackableDialog = ({
  children,
  analytics
}) => analytics ? /*#__PURE__*/React.createElement(Trackable, analytics, children) : /*#__PURE__*/React.createElement(React.Fragment, null, children);